import moment from 'moment';
import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Form } from 'react-bootstrap';
import Highlighter from 'react-highlight-words';

const PatientSearch = (props) => {
    const [clickTimer, setClickTimer] = useState(null);
    const inputRefs = useRef([]);

    const {
        loading,
        setLoading,
        __handleSearchData837,
        patientValue,
        data_837,
        patientIndex,
        hoveredIndex,
        togglePatientHoverEnter,
        handlePatientIndex,
        patientValue1,
        patientValue2,
        setPatientValue,
        cl837Index,
        activate837,
        setData837,
        checkRef,
        handleCheckServiceLines,
        qdxTransaction,
        handleAllCheck
    } = props;

    // Clear data on mount
    useEffect(() => {
        setData837(false);
        setLoading(false);
    }, [setData837, setLoading]);

    // Stable search fields
    const search837Fields = React.useMemo(() => [
        { key: 'patient_account_number', placeholder: 'Account Number', isInput: true, label: "Account Num", class: "width-header-pan", type: "search" },
        { key: 'patient_first_name', placeholder: 'First Name', isInput: true, label: "First Name", class: "width-header-pfn", type: "search" },
        { key: 'patient_middle_name', placeholder: 'Middle Name', isInput: true, label: "Middle Name", class: "width-header-pmn", type: "search" },
        { key: 'patient_last_name', placeholder: 'Last Name', isInput: true, label: "Last Name", class: "width-header-pln", type: "search" },
        { key: 'date_of_birth', placeholder: 'Patient Identifier', isInput: false, label: "Patient Identifier", class: "width-header-identifier", type: "search" },
        { key: 'statement_date', placeholder: 'Payer Name', isInput: false, label: "Payer Name", class: "width-header-payer-name", type: "search" },
        { key: 'statement_address', placeholder: 'Insurance Type', isInput: false, label: "Insurance Type", class: "width-header-insurance-type", type: "search" },
        { key: 'total_charge_amount', placeholder: 'Total Billed Amount', isInput: true, label: "Total Billed Amount", class: "width-header-tba", type: "text" },
        { key: 'tax_identification_number', placeholder: 'Tax ID', isInput: false, label: "Tax ID", class: "width-header-tax-id", type: "search" },
    ], []);

    const searchSelPay837Fields = React.useMemo(() => [
        { key: 'patient_account_number', placeholder: 'Account Number', isInput: true },
        { key: 'mrn_number', placeholder: 'MRN Number', input: false },
        { key: 'patient_first_name', placeholder: 'First Name', isInput: true },
        { key: 'patient_last_name', placeholder: 'Last Name', isInput: true },
        { key: 'date_of_birth', placeholder: 'Date Of Birth', isInput: false },
        { key: 'statement_date', placeholder: 'Statement Date', isInput: false },
        { key: 'statement_address', placeholder: 'Statement Address', isInput: false },
        { key: 'statement_amount', placeholder: 'Statement Amount', isInput: false },
        { key: 'statement_number', placeholder: 'Statement Number', isInput: true },
        { key: 'date_of_service', placeholder: 'Date Of Service', isInput: false },
    ], []);

    // Tab navigation for search fields
    const handleKeyDown = useCallback((e, index, fields) => {
        if (e.key === 'Tab') {
            e.stopPropagation();
            const visibleInputs = fields.filter(item => item.isInput);
            let currentIndex = fields.length - 2 === index ? 4 : index;
            const nextIndex = (currentIndex + (e.shiftKey ? -1 : 1) + visibleInputs.length) % visibleInputs.length;
            const nextInput = inputRefs.current[nextIndex];
            if (currentIndex === 0 || currentIndex === 4) {
                setTimeout(() => {
                    nextInput?.focus();
                }, 0);
            }
        }
    }, []);

    // Single/double click logic
    const handleClick = (ind) => {
        if (clickTimer) {
            clearTimeout(clickTimer);
            setClickTimer(null);
        }
        const timer = setTimeout(() => {
            handlePatientIndex(ind);
            handleAllCheck(null, true);
        }, 300);
        setClickTimer(timer);
    };
    const handleDoubleClick = (ind) => {
        if (clickTimer) {
            clearTimeout(clickTimer);
            setClickTimer(null);
        }
        activate837(ind);
    };

    // Render
    return (
        <React.Fragment>
            <div className="bg-color h-search">
                <div className="search-grid">
                    <div className="py-2 row d-flex align-items-center">
                        <div className="col-lg-1 text-end">
                            <span className="fw-bolder text-white">Search 837 :</span>
                        </div>
                        <div className="col-lg-10 d-flex">
                            {/* Search Inputs */}
                            {/* (Uncomment if you want to show all search fields in a row)
                            {search837Fields.map((item, ind) => (
                                <input
                                    key={item.key}
                                    type="search"
                                    autoFocus={ind === 0}
                                    placeholder={item.placeholder}
                                    name={item.key}
                                    onChange={e => setPatientValue(prev => ({ ...prev, [e.target.name]: e.target.value }))}
                                    className="form-control b-r-10 ms-2 form-control-search never-disable-field"
                                    value={patientValue[item.key]}
                                />
                            ))} */}
                        </div>
                        <div className="col-lg-1">
                            {/* <button type="button" onClick={__handle837Search} className="btn text-white fw-bolder">X</button> */}
                        </div>
                    </div>
                </div>
                <div className='d-flex flex-row gap-4 justify-content-around height-claims' style={{ marginTop: '50px' }}>
                    <React.Fragment>
                        <div className="flex-grow-1">
                            {qdxTransaction === "PATIENT_PAY_835" ? (
                                <ul className="search-837-container-patient-pay list-group list-group-horizontal patient-ul-scroll">
                                    {searchSelPay837Fields.map((item, ind) => (
                                        <li className="list-group-item item-width-full py-1 fs-7 p-0" key={item.key}>
                                            <input
                                                style={{ visibility: item?.isInput ? 'visible' : 'hidden', cursor: loading ? 'not-allowed' : 'text' }}
                                                type="search"
                                                autoFocus={ind === 0}
                                                placeholder={item.placeholder}
                                                autoComplete='one-time-code'
                                                name={item.key}
                                                className='px-2 never-disable-field'
                                                onKeyDown={e => {
                                                    if (e.key === 'Enter' && !loading) {
                                                        let validFields = Object.keys(patientValue).filter(key => patientValue[key].trim().length >= 3);
                                                        if (validFields.length > 0) __handleSearchData837();
                                                    }
                                                }}
                                                onChange={e => {
                                                    if (!loading) setPatientValue(prev => ({ ...prev, [e.target.name]: e.target.value }));
                                                }}
                                                value={patientValue[item.key]}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <ul className="search-837-container list-group list-group-horizontal patient-ul-scroll">
                                    {search837Fields.map((item, ind) => (
                                        <li className={item.class} key={item.key}>
                                            <input
                                                id={`search-837-${ind}`}
                                                ref={el => item.isInput && (inputRefs.current[ind] = el)}
                                                style={{ opacity: item?.isInput ? '100' : '0', cursor: loading ? 'not-allowed' : 'text' }}
                                                type={item.type}
                                                autoFocus={ind === 0}
                                                autoComplete='one-time-code'
                                                placeholder={item.placeholder}
                                                name={item.key}
                                                tabIndex={item.isInput ? 0 : -1}
                                                data-prevent-shift-tab={true}
                                                className='never-disable-field'
                                                onKeyDown={e => {
                                                    handleKeyDown(e, ind, search837Fields);
                                                    if (e.key === 'Enter' && !loading) {
                                                        let validFields = Object.keys(patientValue).filter(key => patientValue[key].trim().length >= 3);
                                                        if (validFields.length > 0) __handleSearchData837();
                                                    }
                                                }}
                                                onChange={e => {
                                                    const value = e.target.value;
                                                    if (e.target.name === 'total_charge_amount' && !/^\d*\.?\d*$/.test(value)) return;
                                                    if (!loading) setPatientValue(prev => ({ ...prev, [e.target.name]: value, is_active: e.target.name }));
                                                }}
                                                value={patientValue[item.key]}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            )}
                            <label className='form-label py-1 ps-1 fw-bold opacity-0'>Claims</label>
                            <div className={qdxTransaction === "PATIENT_PAY_835" ? 'scroll-claim-pp' : 'scroll-claim'}>
                                {qdxTransaction === "PATIENT_PAY_835" ? (
                                    <React.Fragment>
                                        <ul className="search-837-container list-group list-group-horizontal patient-ul-scroll">
                                            {searchSelPay837Fields.map((item, ind) => (
                                                <li className="list-group-item item-width-full py-1 fs-7 p-0" key={item.key}>
                                                    <p className='px-2'>{item.placeholder}</p>
                                                </li>
                                            ))}
                                        </ul>
                                        <div className='mt-4'>
                                            {!loading && data_837 && data_837.length > 0 ? (
                                                data_837.map((patient, ind) => (
                                                    <ul key={ind}
                                                        className={patientIndex === ind ? "list-group list-group-horizontal  active-payee" : hoveredIndex === ind ? "list-group  list-group-horizontal active-mouse-payee" : "list-group  list-group-horizontal"}
                                                        onMouseEnter={() => togglePatientHoverEnter(ind)}
                                                        onClick={() => handlePatientIndex(ind)}
                                                        onDoubleClick={() => activate837(ind)}
                                                    >
                                                        <li className="list-group-item option-item py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[patientValue1?.patient_account_number, patientValue2]} autoEscape textToHighlight={patient?.patient_account_number} />
                                                        </li>
                                                        <li className="list-group-item option-item py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[false, patientValue2]} autoEscape textToHighlight={patient?.mrn_number} />
                                                        </li>
                                                        <li className="list-group-item option-item py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[patientValue1?.patient_first_name, patientValue2]} autoEscape textToHighlight={patient?.patient_first_name} />
                                                        </li>
                                                        <li className="list-group-item option-item py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[patientValue1?.patient_last_name, patientValue2]} autoEscape textToHighlight={patient?.patient_last_name} />
                                                        </li>
                                                        <li className="list-group-item option-item py-1 fs-7">
                                                            {patient?.date_of_birth ? moment(patient?.date_of_birth).format("MM/DD/YYYY") : ""}
                                                        </li>
                                                        <li className="list-group-item option-item py-1 fs-7">
                                                            {patient?.statement_date ? moment(patient?.statement_date).format("MM/DD/YYYY") : ""}
                                                        </li>
                                                        <li className="list-group-item option-item py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[false, patientValue2]} autoEscape textToHighlight={patient?.statement_address} />
                                                        </li>
                                                        <li className="list-group-item option-item py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[false, patientValue2]} autoEscape textToHighlight={parseFloat(patient?.statement_amount ? patient?.statement_amount : 0).toFixed(2)} />
                                                        </li>
                                                        <li className="list-group-item option-item py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[patientValue1?.statement_number, patientValue2]} autoEscape textToHighlight={patient?.statement_number} />
                                                        </li>
                                                        <li className="list-group-item option-item py-1 fs-7">
                                                            {patient?.date_of_service ? moment(patient?.date_of_service).format("MM/DD/YYYY") : ""}
                                                        </li>
                                                    </ul>
                                                ))
                                            ) : (
                                                loading ?
                                                    <div className="text-center p-5">
                                                        <span className="fw-bolder fs-6">Searching...</span>
                                                    </div>
                                                    :
                                                    <div className='py-3 text-center'>
                                                        <span className='fw-bolder'>No data</span>
                                                    </div>
                                            )}
                                        </div>
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        <ul className="list-group list-group-horizontal patient-ul-scroll">
                                            {search837Fields.map((item, ind) => (
                                                <li className={`list-group-item item-width-full py-1 fs-7 ${item.class}`} key={item.key}>{item.label}</li>
                                            ))}
                                        </ul>
                                        {!loading && data_837 && data_837.length > 0 ? (
                                            <div style={{ marginTop: '24px' }}>
                                                {data_837.map((patient, ind) => (
                                                    <ul key={ind}
                                                        className={patientIndex === ind ? "list-group list-group-horizontal  active-payee" : hoveredIndex === ind ? "list-group  list-group-horizontal active-mouse-payee" : "list-group  list-group-horizontal"}
                                                        onMouseEnter={() => togglePatientHoverEnter(ind)}
                                                        onClick={() => handleClick(ind)}
                                                        onDoubleClick={() => handleDoubleClick(ind)}
                                                    >
                                                        <li className="list-group-item option-item width-header-pan py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[patientValue1?.patient_account_number, patientValue2]} autoEscape textToHighlight={patient?.claim_number} />
                                                        </li>
                                                        <li className="list-group-item option-item width-header-pfn py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[patientValue1?.patient_first_name, patientValue2]} autoEscape textToHighlight={patient?.patient_first_name} />
                                                        </li>
                                                        <li className="list-group-item option-item width-header-pmn py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[patientValue1?.patient_middle_name, patientValue2]} autoEscape textToHighlight={patient?.patient_middle_name} />
                                                        </li>
                                                        <li className="list-group-item option-item width-header-pln py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[patientValue1?.patient_last_name, patientValue2]} autoEscape textToHighlight={patient?.patient_last_name} />
                                                        </li>
                                                        <li className="list-group-item option-item width-header-identifier py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[false, patientValue2]} autoEscape textToHighlight={patient?.identifier_code} />
                                                        </li>
                                                        <li className="list-group-item option-item width-header-payer-name py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[false, patientValue2]} autoEscape textToHighlight={patient?.payer_name} />
                                                        </li>
                                                        <li className="list-group-item option-item width-header-insurance-type py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[false, patientValue2]} autoEscape textToHighlight={patient?.insurance_type} />
                                                        </li>
                                                        <li className="list-group-item option-item width-header-tba py-1 fs-7">
                                                            {parseFloat(patient?.total_charge_amount ? patient?.total_charge_amount : 0).toFixed(2)}
                                                        </li>
                                                        <li className="list-group-item option-item width-header-tax-id py-1 fs-7">
                                                            <Highlighter highlightClassName="YourHighlightClass" searchWords={[patientValue1?.tax_identification_number, patientValue2]} autoEscape textToHighlight={patient?.tax_identification_number} />
                                                        </li>
                                                    </ul>
                                                ))}
                                            </div>
                                        ) : (
                                            loading ?
                                                <div className="text-center p-5">
                                                    <span className="fw-bolder fs-6">Searching...</span>
                                                </div>
                                                :
                                                <div className='py-5 text-center'>
                                                    <span className='fw-bolder'>No data</span>
                                                </div>
                                        )}
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                        <div className="flex-shrink-1" style={{ overflowX: "scroll" }}>
                            {!loading && cl837Index >= 0 && data_837 && data_837[cl837Index] && data_837[cl837Index]?.procedure_codes && data_837[cl837Index]?.procedure_codes.length > 0 &&
                                <React.Fragment>
                                    <label className='form-label py-1  fw-bold'>Service Lines</label>
                                    <ul className="list-group list-group-horizontal">
                                        <li style={{ zIndex: '111111' }} className="list-group-item item-width-full-servicelines py-1 fs-7 null-width ">
                                            <Form.Check.Input
                                                className=' checked-servicelines never-disable-field'
                                                type={"checkbox"}
                                                style={{ height: '20px !important' }}
                                                onChange={e => handleAllCheck(e)}
                                                checked={!checkRef?.current?.some(i => i?.checked === false)}
                                                defaultChecked={true}
                                            />
                                        </li>
                                        <li className="list-group-item item-width-full-servicelines py-1 fs-7">#</li>
                                        <li className="list-group-item item-width-full-servicelines py-1 fs-7">Date From</li>
                                        <li className="list-group-item item-width-full-servicelines date-service-to py-1 fs-7">Date To</li>
                                        <li className="list-group-item item-width-full-servicelines py-1 fs-7">Procedure Code</li>
                                        <li className="list-group-item item-width-full-servicelines py-1 fs-7">Billed Amount</li>
                                        <li className="list-group-item item-width-full-servicelines py-1 fs-7">Units</li>
                                    </ul>
                                    {data_837[cl837Index]?.procedure_codes?.map((patient, ind) => (
                                        <ul key={ind} className="list-group list-group-horizontal">
                                            <li className="list-group-item option-item-service  py-1 fs-7 check-width" >
                                                <Form.Check.Input
                                                    className=' checked-servicelines never-disable-field'
                                                    type={"checkbox"}
                                                    disabled={false}
                                                    name='is_check_servicelines'
                                                    onChange={() => handleCheckServiceLines()}
                                                    ref={el => (checkRef.current[ind] = el)}
                                                    value={ind}
                                                    defaultChecked={true}
                                                />
                                            </li>
                                            <li className="list-group-item option-item-service  py-1 fs-7 " >{ind + 1}</li>
                                            <li className="list-group-item option-item-service py-1 fs-7 date-service" >{patient?.date_from ? moment(patient?.date_from).format("MM/DD/YYYY") : ""}</li>
                                            <li className="list-group-item option-item-service py-1 fs-7 date-service-to" >{patient?.date_from ? moment(patient?.date_to).format("MM/DD/YYYY") : ""}</li>
                                            <li className="list-group-item option-item-service proc-service py-1 fs-7 " >{patient?.procedure_code}</li>
                                            <li className="list-group-item option-item-service charge-service py-1 fs-7 " >{parseFloat(patient?.chargeamount ? patient?.chargeamount : 0).toFixed(2)}</li>
                                            <li className="list-group-item option-item-service units-service py-1 fs-7 " >{patient?.units}</li>
                                        </ul>
                                    ))}
                                </React.Fragment>
                            }
                        </div>
                    </React.Fragment>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PatientSearch;